import {AiOutlineHome, AiOutlineUser} from 'react-icons/ai'
import {FcTodoList} from 'react-icons/fc'
import { RiServiceLine } from 'react-icons/ri'
import { TbMessages } from 'react-icons/tb'
import { useState } from 'react'

const Navigation = () => {
  const [activeNav, setActiveNav] = useState('#home')
  return (
    <nav className='bg-black/30 w-max block py-3 px-5 z-[2] fixed left-1/2 -translate-x-1/2 bottom-8 flex gap-2 rounded-[3rem] backdrop-blur-xl'>
      <a href='#home' onClick={() => setActiveNav('#home')} className={`bg-transparent p-3.5 rounded-full flex text-light text-lg hover:bg-black/30 ${activeNav === '#home' ? 'bg-bg !text-white' : ''}`}><AiOutlineHome/></a>
      <a href='#about' onClick={() => setActiveNav('#about')} className={`bg-transparent p-3.5 rounded-full flex text-light text-lg hover:bg-black/30 ${activeNav === '#about' ? 'bg-bg !text-white' : ''}`}><AiOutlineUser/></a>
      <a href='#experience' onClick={() => setActiveNav('#experience')} className={`bg-transparent p-3.5 rounded-full flex text-light text-lg hover:bg-black/30 ${activeNav === '#experience' ? 'bg-bg !text-white' : ''}`}><FcTodoList/></a>
      <a href='#services' onClick={() => setActiveNav('#services')} className={`bg-transparent p-3.5 rounded-full flex text-light text-lg hover:bg-black/30 ${activeNav === '#services' ? 'bg-bg !text-white' : ''}`}><RiServiceLine/></a>
      <a href='#contact' onClick={() => setActiveNav('#contact')} className={`bg-transparent p-3.5 rounded-full flex text-light text-lg hover:bg-black/30 ${activeNav === '#contact' ? 'bg-bg !text-white' : ''}`}><TbMessages/></a>
    </nav>
  )
}

export default Navigation
